define("shared/utils/post/duplicate-post", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.hasUnsupportedMedia = _exports.canDuplicatePost = _exports.PostDuplicationState = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /**
   * Given a Gram and a Social Profile objects, returns if this Social Profile
   * can duplicate posts to
   */
  let PostDuplicationState = _exports.PostDuplicationState = /*#__PURE__*/function (PostDuplicationState) {
    PostDuplicationState["Available"] = "available";
    PostDuplicationState["PastPostLimit"] = "pastPostLimit";
    PostDuplicationState["UnsupportedMedia"] = "unsupportedMedia";
    PostDuplicationState["TwitterSunset"] = "twitterSunset";
    return PostDuplicationState;
  }({});
  const canDuplicatePost = (gram, socialProfile, auth) => {
    if (socialProfile.isTwitter && auth.currentAccount.rolloutTwitterSunset) {
      return PostDuplicationState.TwitterSunset;
    }
    if (!socialProfile.hasPostsLeft) {
      return PostDuplicationState.PastPostLimit;
    }
    if (hasUnsupportedMedia(gram, socialProfile)) {
      return PostDuplicationState.UnsupportedMedia;
    }
    return PostDuplicationState.Available;
  };
  _exports.canDuplicatePost = canDuplicatePost;
  const hasUnsupportedMedia = (gram, socialProfile) => {
    if (gram.isEmptyDraft) {
      return;
    } else if (gram.isCarouselPost && !socialProfile.canCarousel) {
      return 'carousel';
    } else if (gram.isImage && !socialProfile.canPostImage) {
      return 'image';
    } else if (gram.isVideo && !socialProfile.canPostVideo) {
      return 'video';
    } else if (gram.isText && !socialProfile.canTextOnly && !gram.isDraft) {
      return 'text';
    } else if (gram.isGifPost && !socialProfile.canPostGif) {
      return 'gif';
    }
    return;
  };
  _exports.hasUnsupportedMedia = hasUnsupportedMedia;
});